import React, { createContext, useContext, useEffect, useState } from "react";

type WishlistContextType = {
  wishlistIds: string[];
  toggleWishlist: (id: string) => void;
};

const WishlistContext = createContext<WishlistContextType | null>(null);

export const WishlistProvider = ({ children }: { children: React.ReactNode }) => {
  const [wishlistIds, setWishlistIds] = useState<string[]>([]);

  useEffect(() => {
    const saved = localStorage.getItem("user_wishlist");
    if (saved) {
      try {
        setWishlistIds(JSON.parse(saved));
      } catch (e) {
        console.error("Failed to parse wishlist", e);
      }
    }
  }, []);

  const toggleWishlist = (id: string) => {
    setWishlistIds((prev) => {
      let updated: string[];
      if (prev.includes(id)) {
        updated = prev.filter(productId => productId !== id);
      } else {
        updated = [...prev, id];
      }
      localStorage.setItem("user_wishlist", JSON.stringify(updated));
      return updated;
    });
  };

  return (
    <WishlistContext.Provider value={{ wishlistIds, toggleWishlist }}>
      {children}
    </WishlistContext.Provider>
  );
};

export const useWishlist = () => {
  const ctx = useContext(WishlistContext);
  if (!ctx) throw new Error("useWishlist must be used inside WishlistProvider");
  return ctx;
};
